const groupBy = <T, K extends keyof any>(list: T[], getKey: (item: T) => K) =>
    list.reduce((previous, currentItem) => {
        const group = getKey(currentItem);
        if (!previous[group]) previous[group] = [];
        previous[group].push(currentItem);
        return previous;
    }, {} as Record<K, T[]>);

const sortBy = <T, K extends keyof any>(list: T[], getKey: (item: T) => K) => {
    return list.sort((a: any, b: any) => (getKey(a) > getKey(b)) ? 1 : (getKey(b) > getKey(a) ? -1 : 0));
}

const range = (start: number, end: number = 0): number[] => {
    let array: number[] = [];
    for (let i = start; i <= end; i++) {
        array = [...array, i]
    }
    return array;
}

export { groupBy, sortBy, range }